import { css } from 'styled-components';
export interface Media {
  mobile: any;
  tablet: any;
  desktop: any;
  wide: any;
}
export const defaultMediaBreakpoints = {
  mobile: '680px',
  tablet: '1000px',
  desktop: '1280px',
  wide: '1600px',
};

const media = Object.keys(defaultMediaBreakpoints).reduce((memo, val) => {
  memo[val] = (...args: any[]) => css`
    @media (min-width: ${defaultMediaBreakpoints[val]}) {
      ${css(
        // @ts-ignore
        ...args,
      )};
    }
  `;
  return memo;
}, {});

// Phone-specific: targets screens BELOW 680px
export const phone = (...args: any[]) => css`
  @media (max-width: 679px) {
    ${css(
      // @ts-ignore
      ...args,
    )};
  }
`;

export default media as Media;
